module.exports = __webpack_public_path__ + "img/contact.5cb4974e.jpg";